import { Currency } from "./const.mjs";
import { PaymentProvider } from "./provider.mjs";
import { z } from "zod";
//#region src/payment/shared.ts
const currencySchema = z.enum(Currency);
const OnerwayPaymentMethod = {
	CARD: "card",
	GOOGLE_PAY: "google_pay",
	APPLE_PAY: "apple_pay",
	WECHAT_H5: "wechat_h5",
	WECHAT_QR: "wechat_qr"
};
const onerwayPaymentMethodSchema = z.enum(OnerwayPaymentMethod);
const gmoCvsOptionsSchema = z.object({
	paymentMethod: z.string(),
	phoneNumber: z.string()
});
const onerwayOptionsSchema = z.object({ paymentMethod: onerwayPaymentMethodSchema });
const providerOptionsSchema = z.object({
	gmo: gmoCvsOptionsSchema.optional(),
	onerway: onerwayOptionsSchema.optional(),
	paymentMethod: onerwayPaymentMethodSchema.optional()
});
const codeDetailSchema = z.looseObject({
	codeValueType: z.string().nullable(),
	codeValue: z.string().nullable(),
	displayType: z.string().nullable(),
	redirectUrl: z.string().nullable()
});
const codeFormSchema = z.looseObject({
	expireTime: z.string().nullable(),
	codeDetails: z.array(codeDetailSchema).nullable()
});
const onerwayResultSchema = z.object({
	transactionId: z.string(),
	subProductType: z.string(),
	redirectUrl: z.string().nullable(),
	presentContext: z.string().nullable(),
	actionType: z.string().nullable(),
	codeForm: codeFormSchema.nullable()
});
const paypayResultSchema = z.object({
	url: z.string(),
	codeId: z.string(),
	deepLink: z.string()
});
const gmoCvsResultSchema = z.object({
	url: z.string(),
	expiredAt: z.iso.datetime(),
	confNo: z.string(),
	receiptNo: z.string()
});
const providerResultSchema = z.object({
	onerway: onerwayResultSchema.optional(),
	paypay: paypayResultSchema.optional(),
	gmo: gmoCvsResultSchema.optional()
});
const OneTimePurchaseProviders = [
	PaymentProvider.internal,
	PaymentProvider.onerway,
	PaymentProvider.paypay,
	PaymentProvider.apple2,
	PaymentProvider.google3,
	PaymentProvider.gmo
];
const oneTimePurchaseOptionsSchema = z.object({
	provider: z.enum(OneTimePurchaseProviders),
	redirectUrl: z.url().optional(),
	providerOptions: providerOptionsSchema.optional(),
	billingEmail: z.email().optional()
});
//#endregion
export { OneTimePurchaseProviders, OnerwayPaymentMethod, currencySchema, gmoCvsOptionsSchema, gmoCvsResultSchema, oneTimePurchaseOptionsSchema, onerwayOptionsSchema, onerwayPaymentMethodSchema, onerwayResultSchema, paypayResultSchema, providerOptionsSchema, providerResultSchema };
